import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class Preservation extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'preservation'}
            title={ t('support.procedure.P11.title') }
            exportTitle={ t('support.procedure.P11.exportTitle') }
            exportFileName={'preservation.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (Preservation);
